import * as Sentry from 'utils/errorTracking';
import { getAPI } from 'utils/helpers';
import apiClient from 'lib/apiClient';

const TIMEOUT_MS = 5000;

export interface ScheduledLiveStream {
  id: string;
  offeringId: string;
  offeringSlug: string;
  startDate: string;
  status: string;
  startedAt: string | null;
  endedAt: string | null;
  cancelledAt: string | null;
  providerCallId: string | null;
  createdDate: string;
  modifiedDate: string;
}

export interface ScheduledLiveStreamsResponse {
  list: ScheduledLiveStream[];
  pageNumber: number;
  totalElements: number;
  pageSize: number;
  totalPages: number;
}

const EMPTY: ScheduledLiveStreamsResponse = {
  list: [],
  pageNumber: 0,
  totalElements: 0,
  pageSize: 0,
  totalPages: 0,
};

// Client-only: the only caller is useGetScheduledLiveStreams, a React Query
// hook used inside the 'use client' LiveStreamsAlertContainer. If a future
// server-side caller appears, add a ky SSR branch and a matching test.
export const getScheduledLiveStreams = async (): Promise<ScheduledLiveStreamsResponse> => {
  const url = `${getAPI()}/campaign/livestreams/upcoming`;

  try {
    const { data } = await apiClient.get<ScheduledLiveStreamsResponse>(url, {
      timeout: TIMEOUT_MS,
    });
    return data ?? EMPTY;
  } catch (error) {
    const status = (error as { response?: { status?: number } })?.response?.status;
    if (status && status >= 500) {
      Sentry.captureMessage('Gateway 5xx for scheduled livestreams', {
        level: 'warning',
        fingerprint: ['gateway-5xx-scheduled-livestreams'],
        extra: { status },
      });
    } else if (status !== 404) {
      Sentry.captureException(error);
    }
    return EMPTY;
  }
};
